module.exports = __webpack_public_path__ + "img/116.6.91ab2a46.png";